import { Alert, Box, Collapse, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Notification } from '../../../swagger'

export const NotificationBannerAlert: React.FC<{
  userNotification: Notification
  stayOpen?: boolean
}> = ({ userNotification, stayOpen }) => {
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Box
      display="flex"
      sx={{
        width: '100%',
      }}
      key={userNotification.notificationKey}
    >
      <Collapse
        in={stayOpen || isOpen}
        sx={{ width: '100%', mb: isOpen ? 1 : 0 }}
      >
        <Alert
          variant="filled"
          onClose={() => setIsOpen(false)}
          icon={false}
          sx={{
            width: '100%',
            backgroundColor: !!userNotification.color
              ? userNotification.color
              : theme.palette.alert.warning,
          }}
        >
          <Box display="flex" justifyContent="center">
            <Typography
              component="h2"
              variant="subtitle2"
              dangerouslySetInnerHTML={{
                __html: userNotification.body,
              }}
            />
          </Box>
        </Alert>
      </Collapse>
    </Box>
  )
}
